export const setAnalyticsDashletConfig = (state, action) => {
  state.analyticsDashletConfig = JSON.parse(JSON.stringify(action.payload));
};

export const setSelectedAnalyticsDashlet = (state, action) => {
  state.selectedAnalyticsDashlet = JSON.parse(JSON.stringify(action.payload));
};
